import React from 'react'

function DisplayType({ size, color, strokeWidth }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill='none' xmlns="http://www.w3.org/2000/svg">
      <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" />
      <g clip-path="url(#clip0_23056_39218)">
        <path d="M8.78495 8V10.5106H11.7252V8H12.5185V14H11.7252V11.1875H8.78495V14H8V8H8.78495Z" fill={color} />
        <path d="M13.4552 13.5491L15.4301 11.0125C15.6189 10.7814 15.7993 10.5762 15.9988 10.3451V10.3274H13.6356V9.69531H16.9629L16.9534 10.1847L15.006 12.6859C14.8255 12.9264 14.6451 13.1399 14.4468 13.3628V13.3805H16.9988V14.0031H13.454V13.5491H13.4552Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_23056_39218">
          <rect width={size} height={size} fill={color} transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default DisplayType